import { render, staticRenderFns } from "./KvmServiceView.vue?vue&type=template&id=0f144b7e&scoped=true&"
import script from "./KvmServiceView.vue?vue&type=script&lang=js&"
export * from "./KvmServiceView.vue?vue&type=script&lang=js&"
import style0 from "./KvmServiceView.vue?vue&type=style&index=0&id=0f144b7e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f144b7e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0f144b7e')) {
      api.createRecord('0f144b7e', component.options)
    } else {
      api.reload('0f144b7e', component.options)
    }
    module.hot.accept("./KvmServiceView.vue?vue&type=template&id=0f144b7e&scoped=true&", function () {
      api.rerender('0f144b7e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/services/hosting/kvm/KvmServiceView.vue"
export default component.exports